export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/marks.ce3c6a22.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};